// extracted by mini-css-extract-plugin
export default {"hasQuantitySelect":"_c582e24b","followSearchText":"_e1f09480","searchName":"_f23132ab","followTrade":"_f81a9155","followButtonTrade":"_bdd72b83"};